// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"ff0b54eb816f15c53955","3093":"33b2b77f21490c6cfefb","3180":"9f1edef3f69f98a812f7"}[chunkId] + ".css";
};